import { Badge, Button } from 'flowbite-react';
import { useAuth } from '../../hooks/useAuth';

function ImpersonationBanner() {
  const { user, impersonation, stopImpersonation } = useAuth();

  if (!impersonation || !user) return null;

  const canExit = Boolean(impersonation.originalToken);
  const impersonatorLabel = impersonation.impersonator.name || impersonation.impersonator.email;
  const targetLabel = user.name || user.email;

  return (
    <div className="mb-4 rounded-2xl border border-amber-300 bg-amber-50/90 px-4 py-3 text-amber-950 shadow-sm backdrop-blur dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-50">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            <Badge color="warning">Impersonation</Badge>
            <span className="text-sm font-semibold">Working as {targetLabel}</span>
          </div>
          <div className="text-xs text-amber-900/80 dark:text-amber-100/80">
            Signed in as {impersonatorLabel}.
            {!canExit ? ' Original admin session is unavailable in this browser state.' : ''}
          </div>
        </div>
        <Button color="warning" size="sm" onClick={stopImpersonation} disabled={!canExit}>
          Exit impersonation
        </Button>
      </div>
    </div>
  );
}

export default ImpersonationBanner;
